var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEnvironmentOutlined = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 2C8.69 2 11.024 3.517 12.197 5.741C13.374 4.083 15.31 3 17.5 3H21V5.5C21 9.09 18.09 12 14.5 12H13V13H18V20C18 21.105 17.105 22 16 22H8C6.895 22 6 21.105 6 20V13H11V11H9C5.134 11 2 7.866 2 4V2H6ZM16 15H8V20H16V15ZM19 5H17.5C15.015 5 13 7.015 13 9.5V10H14.5C16.985 10 19 7.985 19 5.5V5ZM6 4H4C4 6.761 6.239 9 9 9H11C11 6.239 8.761 4 6 4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    transform: "matrix(-1 0 0 1 16 16)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 9.5C10.6667 8.66667 9.7 7 8.5 7C7.3 7 9.66667 8.66667 11 9.5Z",
    stroke: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEnvironmentOutlined, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/EnvironmentOutlined.f0a3aeb6.svg";
export { ForwardRef as ReactComponent };